import cssVariables from 'tfs.css-variables'

export default {
  removeNotificationIcon: {
    fontSize: '2rem',
  },
  notification: {
    display: 'flex',
    flexFlow: 'row',
    padding: '1rem 2rem',
    borderBottom: `1px solid ${cssVariables.colorGrayE}`,
    justifyContent: 'space-between',
  },
  success: {
    backgroundColor: cssVariables.colorSuccessBackground,
    boxShadow: 'inset 0 -0.125rem 0.25rem 0 rgba(0,0,0,0.2)',
    borderRadius: '0 0 0.5rem 0.5rem',
  },
  error: {
    backgroundColor: cssVariables.colorErrorBackground,
    boxShadow: '0 3px 5px -1px rgba(0,0,0,0.1)',
    borderRadius: '0 0 0.5rem 0.5rem',
  },
}
